import { useState } from 'react';
import { saveapps } from '../components/DbServices';
import Swal from 'sweetalert2';

export default function AddAppModal({ onClose, userId }) {
  const [appName, setAppName] = useState('');
  const [loading, setLoading] = useState(false);
  const [apiKey, setApiKey] = useState(null); // To show the key after generation

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!appName) return Swal.fire("Please enter an App Name");

    setLoading(true);
    try {
      const payload = {
        user: userId,
        name: appName,
        status: 1
      };

      const res = await saveapps(payload);
      if (res.status === 200 || res.success) {
        // Assume the API returns the key in res.data.api_key
        setApiKey(res.data.api_key);
      }
    } catch (err) {
      Swal.fire("Failed to generate API key");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(apiKey);
    Swal.fire("API Key copied to clipboard!");
  };

  return (
    <div className="custom-modal-backdrop" style={{ alignItems: 'center' }}>
      <div className="custom-modal border-0 shadow-lg" style={{ maxWidth: '500px', width: '95%', borderRadius: '20px', overflow: 'hidden', padding: '0' }}>
        
        {/* Header with your Gradient Class */}
        <div className="bg-primary p-4 text-white text-center">
          <h5 className="fw-bold mb-0">Create API Integration</h5>
          <p className="mb-0 x-small text-white-50">Connect external tools to your WhatsApp</p>
        </div>

        <div className="p-4 bg-white">
          {!apiKey ? (
            <form onSubmit={handleSubmit} className="fade-in">
              <div className="mb-4">
                <label className="small fw-bold text-muted mb-2 text-uppercase" style={{ letterSpacing: '0.5px' }}>
                   Application Name
                </label>
                <input 
                  type="text" 
                  className="form-control form-control-lg border-2" 
                  style={{ borderRadius: '12px', fontSize: '1rem' }}
                  placeholder="e.g. WooCommerce Store" 
                  value={appName}
                  onChange={(e) => setAppName(e.target.value)}
                  required
                />
                <div className="form-text mt-2 small">
                  <i className="bi bi-info-circle me-1"></i>
                  This name helps you identify the source of incoming requests.
                </div>
              </div>

              <div className="d-flex gap-2">
                <button type="button" className="btn btn-light w-100 fw-bold py-2 border" onClick={onClose}>Cancel</button>
                <button type="submit" className="btn btn-primary w-100 fw-bold py-2 shadow-sm" disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  ) : 'Generate API Key'}
                </button>
              </div>
            </form>
          ) : (
            /* Success State: Showing the Key */
            <div className="text-center py-2 fade-in">
              <div className="mb-3 text-success">
                <i className="bi bi-check-circle-fill" style={{ fontSize: '3rem' }}></i>
              </div>
              <h6 className="fw-bold">API Key Generated Successfully!</h6>
              <p className="small text-muted mb-4">Copy this key now. For security, you won't be able to see it again.</p>
              
              <div className="input-group mb-4 shadow-sm">
                <input 
                  type="text" 
                  className="form-control bg-light border-end-0 text-center fw-bold" 
                  value={apiKey} 
                  readOnly 
                />
                <button className="btn btn-primary px-3" onClick={copyToClipboard}>
                   <i className="bi bi-clipboard"></i>
                </button>
              </div>

              <button className="btn btn-dark w-100 fw-bold py-2 rounded-pill" onClick={onClose}>
                Done & Close
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}